
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1f5b645a75d5c5ac': html`
            <p>
              Como parte de tu incorporación, necesitarás realizar una configuración inicial de tu cuenta antes de poder comenzar a vender tus servicios.
            </p>
            <p>
              Cuando estés listo(a), presiona aquí (te llevará a la página de configuración).
            </p>
          `,
'hcd9d4fc56615709f': html`ENTRENA MÁS INTELIGENTE • PONTE EN FORMA • VUÉLVETE PRO`,
's005053d82b712e0a': `Notas`,
's019efedacc31ba10': `perdido`,
's0279db1c6f449ab7': `Análisis de Negocio`,
's02cf66a0a0653ff8': `Detalles del Registro de Entrenamiento`,
's05a351a51219b0fe': `Nadie`,
's06e80315ac9995b9': `Ninguno aún`,
's091d3d07b5b3076f': `OK`,
's09b77ef3824e4088': `Agua Corporal Total`,
's0a2ca898b54a4f56': `¡Bienvenido(a)!`,
's0c442cbbc17f0de9': `Por favor, inicia sesión para continuar.`,
's0c7f3e5e3c15f428': `Continuar sesión`,
's0ce7d9675a8b7732': str`3. Plazos ${0} condiciones`,
's0ec54510233409c5': `Falla al publicar el plan: `,
's0fbf6dc6a1966408': `Próximo`,
's0fe87ed1fc09cf34': `Tu logo también se usará como tu foto de perfil.`,
's1150c078d9cee26d': `% Grasa Corporal`,
's12efa94f2e4bdcc3': `Repeticiones`,
's12ffcaf2e502ac82': `error sin archivo`,
's13a2e3afa0779b53': `Planes`,
's13cefa7424ff2e27': `Filtrar clientes`,
's15e23319b09fd2e3': `IMC`,
's192f232455c1b65d': `Anexar abajo`,
's19f8a91fef089a4a': `Suscripción:`,
's1a73a3c2401c31ea': `¡Bienvenido(a) aquí!`,
's1bf0c7472ae25a6f': `Casi listo — aún falta:`,
's1bf9fe1883d69bf9': `Para mejores resultados, usa logos de 200 x 200 píxeles y en formato SVG. Aunque también se aceptan archivos en formato webp, jpg y jpeg.`,
's1d318e9d0ccba86b': `Chat`,
's1e05ab3c077ad402': `Alternativa: Bioimpedancia / InBody`,
's1e187119b5262c59': `Máx.`,
's1f7698c061c208c9': `Abrir`,
's2011fc99c027dbb1': `días de racha`,
's203e1da56bd2e626': str`${0}semanas`,
's215ad519258e9d97': `ahora`,
's217f47ce4db59c2e': `Masa Libre de Grasa`,
's21b06c38fc4164db': `Avanzado`,
's222859294d7fb3a3': `Filtrar planes`,
's230cf829634bac2a': str`Hombros`,
's2350bef19b9f2588': `Envío de fotos`,
's24b779bb2fb9847b': str`Vence: ${0}`,
's262463042abb35d7': `¡Gracias! Tus respuestas han sido registradas.`,
's2626be9fb3554c7d': `Copiar secciones siguientes`,
's26db9189a75bef43': str`${0} Nuevos`,
's26f4e57f53965b7c': `Cliente desconocido`,
's26f55ad32da5d49c': `Requiere atención`,
's26fceaca777a7b8d': `No hay ejercicios`,
's2840abad0770c57b': str`Pantorrillas`,
's2a87c777df650b17': `Suscripción mensual`,
's2accc8370816a278': `ejercicios`,
's2b0df9e2b26a4f87': `Gimnasio Completo`,
's2b9d55453f4356bb': `URL de YouTube:`,
's2c86969637ae0fe3': `Entrega del entrenamiento`,
's2ceb11be2290bb1b': `Cancelar`,
's2d5ebf2d00a77043': `próximo`,
's2dacbbc50eda12a6': `Debes tener en cuenta que, en ausencia de las evaluaciones mencionadas, no se considerará cierta información importante; la asesoría se llevará a cabo, pero su eficacia podría reducirse.`,
's2e51ab74561f5024': `Seleccionar Usuario`,
's2ed82ff088ba5782': `Términos y Condiciones del Proveedor de Servicios del Entrenador`,
's2ef90cfc73edcac2': str`Ver todos (${0})`,
's2f3dd8b8ea2006fb': `Aún no hay entrenamientos disponibles`,
's2fccc807af87ee35': `Progreso Semanal`,
's305c088da2474ea2': `Preguntas`,
's307ebbf519f93ea5': `Última sesión`,
's30959594f2efe182': `Cliente desde:`,
's30fba8ef68ba39e7': `Nombre del Entrenamiento:`,
's3375a4920652b810': `Series`,
's33f85f24c0f5f008': `Guardar`,
's356afc5e8bdabfb3': `Entregar`,
's3651ca5688e7b9d8': `Fallo al guardar el plan`,
's3687049d1af562c4': `Copiar`,
's382a2aa3984474dd': `Crear`,
's388be1e86199883f': str`${0} abiertos`,
's38e8273daf1ff536': str`Entrenamiento ${0}`,
's395b013b1b16b33f': `Acepto los Términos de Servicio de mi entrenador.`,
's399cc2d67d92e957': `Confidencial`,
's3a03fffca0dbc126': `No hay acciones pendientes`,
's3afaa4fbbbc61a5c': `Pérdida de Peso`,
's3bbe3ec0204334f9': `Términos y Condiciones de Uso de TrainFitPro`,
's3d69183691314fd8': str`${0}h`,
's3f578e92d19ba2fc': str`Vista frontal - activos: ${0}`,
's3fafae6168b9e553': str`${0} entrenamientos`,
's42371020b1129113': `Hipertrofia`,
's427dc85ddc28b8e7': `Describe cirugías anteriores, dolores articulares (hombro, rodilla, columna) o cualquier restricción médica importante…`,
's4295bddca90bec76': str`Pecho`,
's42bc0e4e1a6c3e62': `Obligatorio`,
's4312bcbe1a680288': `Rehabilitación`,
's445e9135e4c219ae': `Masa Muscular`,
's44629f179e18b32f': str`Guardar ${0} Continuar`,
's45274a2e84266fa0': `Por favor, acepta a continuación (aceptando también los Términos y Condiciones del Entrenador)`,
's455a725a7c83d8ac': str`#${0} en facturación`,
's467b030b9a34b3c8': `Promedio`,
's46d6587089bd0356': `Mes siguiente`,
's46ec6540ada4ea9b': `Índice`,
's48adf6580103ef59': `Por favor, revisa los Términos y Condiciones y la Política de Privacidad antes de registrarte.`,
's48e186fb300e5464': `Tiempo`,
's4908d5eb206e4557': `Tu logo, por ejemplo, se verá así:`,
's4911f2c56a916d5d': str`Nombre del plan:`,
's4ab2d3cc63bec077': `Vista previa:`,
's4abcddbf0c24a4e2': str`hace ${0}d`,
's4b8e5ca433fe9a85': `Pago Vencido/Próximo`,
's4da7b16439206463': `Planes Vencidos/Próximos`,
's4ec95ab5f10e0b0d': `Borradores`,
's4f299dd888a2df8f': `La captura de pantalla aparecerá en este cuadro.`,
's4f99f3802d8a5872': `Medición de los pliegues cutáneos (7 u 9) + perimetría o bioimpedancia completa. De no ser posible, realizarla en la máquina InBody.`,
's4fe76110dab46192': `Fallo al guardar el plan: `,
's501040845af84498': `Descanso`,
's509ec2f4900e39b4': `Biometría`,
's517acbf1f96324f9': `Musculación`,
's51a431d68ff7c47b': `Continuar con Google`,
's536db73f020e2ae0': `Transmisión de video no disponible.`,
's539b014cd449ae45': `Índice Cintura-Cadera`,
's53e04be816af4a73': `Entrega`,
's54b533d717a48b22': `20 días`,
's554a1cea9b6d9afd': `Es deseable una evaluación física con medición de los pliegues cutáneos (7 u 9) + perimetría o bioimpedancia completa.`,
's55a007290e2b73f1': `A continuación`,
's55d09572312d435d': str`${0} Activos`,
's58c19d887aafd7a5': `Iniciar nueva sesión`,
's58d7e2a809948cdd': `Vestimenta adecuada`,
's590ec3849dee58d1': `Las fotos deben tomarse en ropa de baño (bikini o sunga).`,
's595fe6f3b8aaa6a9': `Simulación de Plan`,
's59675d3bb2b7b629': `Descripción:`,
's59d8decc425c79b0': `Lamentablemente, no tienes autorización para usar esta aplicación. Por favor, vuelve a intentarlo más tarde.`,
's5b177391f91aa762': str`Vista posterior - activos: ${0}`,
's5b3ea8291adf04ec': `Para uso futuro`,
's5cd3748fb8081f0b': `Objetivo Principal`,
's5cdcc3c2505d0a32': `Tu resultado de entrenamiento ha sido guardado`,
's5d8b4ca459b9a978': `Diario`,
's5dc4d095d9970f7e': str`${0}días`,
's5e8250fb85d64c23': `Cerrar`,
's5f4134772e7bb890': `Ver toda la actividad`,
's5f4586bc1e2740e6': `Borrar búsqueda`,
's60cc10ca9e096620': `Oficial`,
's62931b2a50168976': `Mes anterior`,
's631ed9c4eef50981': `Métricas del Servicio`,
's63461adc1045292c': `Iniciar entrenamiento`,
's6430981650a5df60': `Equipamiento Disponible`,
's65b179f701078347': `Sin preguntas`,
's66413c24dcf680e2': `Omitir`,
's664ccd1b2b37fccc': `Pagos Vencidos/Próximos`,
's67749057edb2586b': `Cerrar sesión`,
's6778df312dec45f0': `Solo Peso Corporal (Calistenia)`,
's6884ff7dcc93619f': `Selector de Cliente`,
's68f932d22e504054': `Movilidad`,
's6a2844e7aaa48d5c': str`Sesiones de entrenamiento promedio por semana: A definir`,
's6a67c73c319177f1': `El plan ha sido publicado`,
's6a8e33eda365346e': `Así es como se verá:`,
's6aa7ad9440de4905': `a partir de la fecha de pago`,
's6ad744e56c5f3a42': `Subir tu logo`,
's6b269e8e8e93d748': `Acepto los Términos y Condiciones y la Política de Privacidad.`,
's6c10576661997054': `Nombre:`,
's6d08351212b63683': `Configurar tu Anamnesis`,
's6d3b5b0561ba34c9': `Publicados`,
's6d7efb5ab40b33b4': `Suscripción`,
's6de3d6e9660857a1': `Ejemplo`,
's6fa7fe2095471e0b': `Peso Corporal`,
's70478974fa7eccb4': `Masa Grasa`,
's708334df3634ad8b': `Evaluación Inicial`,
's72b0e48e2a286710': `Preguntas de tu Entrenador`,
's73280c5c08612b65': `Ocurrió un error al guardar: `,
's7383555c44bf3d93': `Crear carpeta`,
's74982e57a1d8896c': `Configuración Avanzada`,
's7707a80d4dc2ad6f': `He leído y estoy al tanto de todas las instrucciones, la vestimenta recomendada y los plazos establecidos por la asesoría.`,
's773f2473fde48117': `Ventas`,
's77bd3ee683e4f8c2': `Altura y centrado de la cámara`,
's77dde5ef6c52def6': `Moneda`,
's78104df0504716a8': `Selector de Multimedia`,
's79e8cc71a5975b04': `Mensaje`,
's7d53050a50cff2fc': `No realices ningún corte ni edición en las fotografías. Si están fuera del estándar, deberán repetirse.`,
's7da0c77635fbed00': `¿Estás seguro(a) de que quieres eliminar estas secciones/entrenamiento?`,
's7df56dd45cc6277f': `Observaciones de hoy`,
's7ee8cdf05d4fbb1d': `Demasiado largo`,
's7f3437809d931336': `Revisiones`,
's818f17de976629e1': `Guardando`,
's81d30c913ed714f6': `Elige tus términos:`,
's81ecf2d4386b8e84': `Continuar`,
's81f8e4b4a6dcfd17': str`Dorsales`,
's826b68dbee24a53f': `En vivo`,
's83521d49a1b58158': `Gestor de Multimedia`,
's85186a61e0d55bac': `Video`,
's855293e72dd930fa': `Nombre del Ejercicio`,
's8578c6253fc59879': `Experiencia de Entrenamiento`,
's878d4efff55e28ec': `Diario`,
's89e396ff03e2a702': `La cámara debe estar a la altura de tu cadera y bien centrada (en fotos en el suelo, cámara en el suelo también, a la mitad de tu cuerpo). Si alguien te las toma, pídele que se siente en una silla.`,
's8ab070f3fa0ae40b': str`Historial Médico ${0} Limitaciones`,
's8b0432eecbd8b034': `Actualizar`,
's8b97ea84af17c029': `Nunca`,
's8c1837e74a81ad0d': str`hace ${0}m`,
's8df195c27586582e': str`Faltan ${0} días para la fecha límite del plan`,
's8fae5de4533e1b4c': `Cliente:`,
's900f0929459f61e9': `Acepto los Términos de Servicio y la Política de Privacidad de la plataforma.`,
's9103a7851a988739': str`Mancuernas ${0} Bancos en Casa`,
's928fcb256b35c21e': `No se seleccionó un plan`,
's92921878e886e36d': `Duración`,
's92a0d19a28995530': `Éxito`,
's92f6b4aa709c97a6': `Cuerpo entero (de pies a cabeza)`,
's92f757b31c9251d5': `No enviar las fotos dentro de los 20 días a partir de la fecha de pago configura el abandono del cupo, por lo que será indispensable realizar un nuevo pago de señal para reactivarlo. En caso de desistencia de la asesoría por parte del alumno, no habrá devolución del valor pagado.`,
's937419baa2473f73': str`${0} días después de la fecha límite del plan`,
's9435457c0d47ca15': str`Bienvenido(a) ${0}`,
's95fbda399bb97206': `Pagos`,
's96668830629e0dfc': `Subir`,
's96e17d77681b5b4c': `Frecuencia Semanal`,
's970895c07251f7cf': `Disciplina`,
's99858602e18ca08c': `Configurar tus Métricas de Servicio`,
's99fa943a22c13e67': `Explorar`,
's9a06e76cc4d72a0d': str`Lumbar`,
's9ae739bba204c8b9': str`Isquiotibiales`,
's9b06b628da2c361d': `Buscar…`,
's9b3033813c8d813f': `Inicio:`,
's9d0918cba6fff4a9': `Volver a la página de inicio de sesión`,
's9d0ad7d89be68710': str`Hola ${0}`,
's9d8b8aa2b404c2c8': `Configuración`,
's9ebf600d37322503': str`Trapecio`,
's9fe64b90c760379e': `Publicando`,
'sa06e60ff826e4c2a': `Importante sobre retrasos y desistencias`,
'sa1664c25091fa385': `¡Buen trabajo completando tu sesión de entrenamiento!`,
'sa18421c24fe0e455': str`Oblicuos`,
'sa2f16f3d642af032': `Métrica de plan`,
'sa31966cbbb99c765': str`Entrenamientos de ${0} ${1}`,
'sa38ee475e1cf8a87': str`Cuádriceps`,
'sa53c1dc8336bb9f0': `Biomecánica`,
'sa6a49e20c2bb1d36': `Regístrate con el proveedor de pagos y realiza la configuración.`,
'sa6f091b5420239ee': str`Protocolo de Biometría ${0} Evaluación Físico-Postural`,
'sa701dab6cda5cc99': `Entrenamientos de clientes`,
'sa75be35c199bd66e': `Aún no hay racha`,
'sa7b534c9d0d50518': `Ninguno nuevo`,
'sa835bf6d362a9e2a': `Detalles del Entrenamiento`,
'sa86c00822bc55c28': `Tu logo se usará generalmente como un cuadrado.`,
'sa86ea054ad5277ce': str`hace ${0}h`,
'saafb40b251029280': str`Foto ${0}/${1}`,
'sab35bad30d0f7621': `Para estos entrenamientos`,
'sab82b3493b817037': `Configurar información de precios`,
'sab97bbe86d4cf4fe': str`Diagnóstico`,
'sac4f71b0ddb45d28': `Ninguno activo`,
'sad3a2d2a8a492607': `Principiante`,
'sadab6bd5bd26fc3c': `El plan ha sido guardado`,
'sadcec236f39d307e': `Medios seleccionados:`,
'sae4e38f41939b1ae': `1. Para empezar`,
'sae5d87e99fe081e0': `Obligatorio`,
'sb02dad2922157cbc': str`${0} Sin respuesta`,
'sb0abfc899f7e4275': `Evaluación física`,
'sb2e14cf8b4f7b963': `Protocolo de evaluación física`,
'sb39c29728a3aab64': `Intermedio`,
'sb3d2d8e2a3cedc49': `Configura tus Términos de Servicio`,
'sb5526ccbe8ba805f': `Por plan`,
'sb65c789c0a5ab012': `Este proceso es fundamental para armar tu entrenamiento, ¡así que esmérate!`,
'sb788a72b606be4bb': `Acepto los Términos y Condiciones y la Política de Privacidad del Entrenador.`,
'sb8a63343939caf0d': `2. Estándar fotográfico`,
'sb940896159f93891': `Ninguno pendiente`,
'sb9d1f408dc81dd97': str`Evaluación Inicial ${0} Prescripción`,
'sba5b7a8f4f902926': `¡Entrenamiento completado!`,
'sbb94361ed4568464': str`Antebrazos`,
'sbbb2f46c5f00dbf0': `Fin:`,
'sbca15f638701d792': `Acondicionamiento`,
'sbd465ea9bd2a1498': `Objetivo`,
'sc09f68b387d96596': `Requisitos iniciales`,
'sc31690556c9b1f9b': `Tus respuestas definen directamente tu periodización del entrenamiento, el descanso y la intensidad biomecánica.`,
'sc360b1d435428cb1': `Revisiones de Video`,
'sc3da2b6f02afab19': str`Bíceps`,
'sc68080ce046320cb': `Vencidos`,
'sc8002664eec439d7': `Cardio`,
'sc8379accd3fbc340': `Entrenador Oficial`,
'sc9da556492c87421': `Gestor de Clientes`,
'sc9e36319670bfb2c': `Aún no hay mensajes`,
'sca10e25b4cf014c2': str`Iniciar Envío de Fotos (1/${0})`,
'scb837422e05acc02': `Metabolismo Basal`,
'scbd8031e3d026dc9': `nunca`,
'scc7a3682dd25ae19': `Opcional`,
'sccf853136930cdcb': `Escribe el nombre del plan o cliente`,
'scd7b43bc6ecb4dc0': `Tu entrenador`,
'scea321ca3da7a0d6': `Filtrar por estado`,
'scfcffcf35292bc6f': `Simular`,
'sd18e54cff4a91578': `Subir Material`,
'sd1aede1413271800': `Tipos de frecuencias de pago ofrecidas`,
'sd31a11e89b9882c2': `Cariello Academy`,
'sd3f6a8d871bcddec': str`${0} para ${1}`,
'sd4647caeb94889ec': `Términos`,
'sd5683140bd6412b7': `Días dedicados`,
'sd56b740816b8f863': `Series (separadas por comas)`,
'sd57e22d10c6d1167': `Lamentablemente has encontrado un error en la aplicación. El error ha sido registrado y estaremos trabajando para resolver el problema.`,
'sd593bc8a3c220ed2': str`Vencido hace ${0} días`,
'sd6cd4f2ac3777759': `Peso:`,
'sd6ddac8adb73147d': `Ocurrió un error al guardar: `,
'sd8245bf18e9d2136': `Personaliza tu camino de entrenamiento`,
'sd97345198e73f26c': `ERROR`,
'sda05a2d4cdf1fa30': `Fallo durante la publicación del plan, ¿ya está publicado?`,
'sdafe5c93c20d2066': `Ocurrió un error durante la publicación: `,
'sdb39991315523ef4': `Sin cortes ni ediciones`,
'sdb9694f31d64cfc8': `Tu respuesta`,
'sdc0a98f90dcd8e8b': `Publicar plan`,
'sdc12d4d35420eeb7': `Comentarios`,
'sdc673e73b5c13aea': `Eliminar`,
'sdcdd12bef40e339e': `YouTube`,
'sde5b338d06c7957a': `Términos y Condiciones del Entrenador`,
'sde75a191a5b33d9d': `Las fotos deben tomarse a una distancia en la que se te pueda ver desde los pies hasta la cabeza.`,
'sdf13400f7244ec63': `SLA de la asesoría`,
'sdf9d3ebb59974cdf': `Tareas Pendientes`,
'se0f2aaae51472ca4': `Acepto los Términos y Condiciones y la Política de Privacidad de TrainFitPro.`,
'se11c5a35b7c2f7e3': str`Tríceps`,
'se2eaf692ffa79456': `Estiramiento`,
'se3f7057c15a6332d': `Volver a la página de inicio`,
'se449f1215ef49707': `Actividad Reciente`,
'se59701fa8cbad9a9': `Seleccionar entrenamientos y ejercicios`,
'se70419f87c03926e': `Continuar con el plan guardado u omitir`,
'se7dbe9f0dcd4b207': `Finalización`,
'se9e2b9ef470e7ee4': `Elige tu logo:`,
'seaa9f673a49ff037': `De no ser posible, realizar la evaluación en la máquina InBody y adjuntar el informe completo.`,
'seadc1710dddab9e2': `Métrica de preguntas`,
'sebabfcac377bce0c': `Métrica de revisión de video`,
'secb6e418f6aee0ac': `Nacimiento:`,
'sed0a610da2d865be': `Fallo durante la actualización, publicación del plan`,
'sed413c5e180d6edb': `Ingresos`,
'seed76e8afe9f604a': `Precio`,
'sef5248c6cf6b0068': `Regístrate en los servicios de`,
'sef7848f0523aff43': `Calendario de racha de entrenamiento`,
'sefcf950b3cc4fc3b': `Idioma`,
'sf0765e244cd21df0': `Desglose de ejercicios`,
'sf2001d4551fa38ca': `Tu entrenador revisará tu anamnesis y te responderá pronto.`,
'sf2fec0d6b852774c': `Importar plan existente`,
'sf3a729179a574a75': `No hay elementos pendientes`,
'sf3cacc3f38fd080c': `Por vencer`,
'sf3ff78cc329d3528': `Anterior`,
'sf404dc6e56b8cfca': `Peso en kg`,
'sf5cd13af5eb03760': `Configurar tu Evaluación`,
'sf5dc01a3ccf20c4a': str`Serie ${0}`,
'sf5f7f77ab9c1baaa': `Cambiar foto de perfil`,
'sf6c15fd6d6110c75': `Lee las instrucciones y marca la casilla de arriba para comenzar el envío de las fotos.`,
'sf87feb4049f6f275': `Entrenamientos`,
'sf993bb199fefbe04': `Todos`,
'sf9aee319a006c9b4': `Añadir`,
'sf9c2d219a01755db': str`Abdomen`,
'sfc4444d68ac3a49f': `a partir del envío de las fotos`,
'sfc63e31ac7c956ed': `Seleccionar`,
'sfcd2e536e51f1567': str`Glúteos`,
'sfd3f66de651ccd9f': `Progreso de la carga:`,
'sfdde30c24ce38292': `completado`,
'sfe17eee9aeb43052': str`${0} Pendientes`,
'sfe9a2c05e71c261a': `Entrenamientos Completados`,
'sfec9c11e84f72d03': str`Vence en ${0} días`,
'sff0c83419b929db1': `Buscar clientes…`,
'sff5bb7742c2896c8': `Objetivo`,
    };
  